import React from "react";

const CrownWhite = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.1603 6.26174C22.243 6.11149 22.3645 5.98619 22.5122 5.89893C22.6599 5.81166 22.8282 5.76562 22.9998 5.76562C23.1713 5.76562 23.3397 5.81166 23.4873 5.89893C23.635 5.98619 23.7565 6.11149 23.8393 6.26174L29.4973 17.0027C29.6322 17.2515 29.8205 17.4672 30.0487 17.6345C30.2769 17.8018 30.5393 17.9165 30.8171 17.9704C31.0948 18.0243 31.3811 18.016 31.6553 17.9461C31.9295 17.8762 32.1848 17.7465 32.4029 17.5662L40.6005 10.5436C40.7579 10.4156 40.9518 10.3408 41.1543 10.3301C41.3569 10.3193 41.5576 10.3731 41.7277 10.4837C41.8977 10.5943 42.0283 10.756 42.1006 10.9455C42.1729 11.135 42.1832 11.3426 42.13 11.5383L36.6982 31.1765C36.5873 31.5784 36.3484 31.9331 36.0178 32.187C35.6871 32.4409 35.2827 32.58 34.8658 32.5833H11.1356C10.7184 32.5804 10.3135 32.4415 9.98251 32.1876C9.65146 31.9337 9.4123 31.5787 9.30134 31.1765L3.87142 11.5402C3.81823 11.3445 3.82853 11.1369 3.90083 10.9474C3.97312 10.7579 4.10369 10.5962 4.27373 10.4856C4.44377 10.375 4.64452 10.3212 4.84708 10.332C5.04964 10.3427 5.24356 10.4175 5.40092 10.5455L13.5966 17.5682C13.8147 17.7484 14.07 17.8781 14.3442 17.948C14.6184 18.0179 14.9047 18.0262 15.1824 17.9723C15.4602 17.9184 15.7226 17.8037 15.9508 17.6364C16.179 17.4691 16.3673 17.2534 16.5023 17.0047L22.1603 6.26174Z"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.58398 40.25H36.4173"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CrownWhite;
